import { render, staticRenderFns } from "./CommercialProductExtraInfoForm.vue?vue&type=template&id=1a6a15e8&scoped=true&"
import script from "./CommercialProductExtraInfoForm.vue?vue&type=script&lang=js&"
export * from "./CommercialProductExtraInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a15e8",
  null
  
)

export default component.exports